import { useNavigate, useParams } from 'react-router-dom';
import { ClienteDetailPage } from './ClienteDetailPage';
import { ClienteEditOverlay } from './ClienteEditOverlay';

/**
 * Deep-link route /clientes/:id/edit: renders the Cliente 360 page with the
 * edit overlay ALWAYS open on top. The ordinary edit click from the detail
 * page does NOT navigate here — it opens the same overlay in memory so the
 * active tab URL (/clientes/:id/:tab) is preserved underneath. Closing or
 * saving from this route returns to the canonical /clientes/:id.
 */
export function ClienteEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const clienteId = Number(id);
  const returnToDetail = () => navigate(`/clientes/${clienteId}`);

  return (
    <>
      <ClienteDetailPage editOverlayManagedExternally />
      <ClienteEditOverlay clienteId={clienteId} open onClose={returnToDetail} />
    </>
  );
}
